import { FormType } from '@/__generated__/types';

export const FORM_TYPE_OPTIONS = [
    FormType.NewMerchant,
    FormType.DemoRequest,
    FormType.Support,
    FormType.Partnership,
    FormType.GeneralEnquiry
] as const;

export const FORM_TYPE_LABELS = {
    [FormType.NewMerchant]: 'New Merchant',
    [FormType.DemoRequest]: 'Demo Request',
    [FormType.Support]: 'Support',
    [FormType.Partnership]: 'Partnership',
    [FormType.GeneralEnquiry]: 'General Enquiry'
} as const satisfies Record<FormType, string>;
